import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { DataTablesModule } from "angular-datatables";
import { MrpTableComponent, DynamicTableComponent, LoaderComponent } from "@app/shared";
import { CommonModule } from "@angular/common";
import { FlattenObjectPipe } from "@app/pipes/flatten-object.pipe";
import { MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { NotificationComponent } from "@app/shared/notification/notification.component";
import { MrpAccountTreeComponent } from "@app/shared/mrp-account-tree/mrp-account-tree.component";
import { CdkTableModule } from "@angular/cdk/table";
import { CdkTreeModule } from "@angular/cdk/tree";
import { MatTableModule } from "@angular/material/table";
import { RouterModule } from '@angular/router';
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { 
// MatSidenavModule,
MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTreeModule } from "@angular/material/tree";
import { NgChartsModule } from 'ng2-charts';

const materialModules = [
  MatInputModule,
  MatFormFieldModule,
  MatButtonModule,
  MatMenuModule,
  MatToolbarModule,
  MatIconModule,
  MatCardModule,
  MatSelectModule,
  MatListModule,
  // MatSidenavModule,
  MatGridListModule,
  MatCheckboxModule,
  NgbModule,
  FontAwesomeModule,
  DataTablesModule,
  CommonModule,
  MatRippleModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDividerModule,
  MatRadioModule,
  MatSliderModule,
  MatTreeModule,
  MatExpansionModule,
  MatTableModule,
  RouterModule,
  MatPaginatorModule,
  MatSortModule,
  MatSnackBarModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatTooltipModule
];
//
const components = [
  // NavbarTopComponent,
  // NavbarBreadcrumbsComponent,
  // NavbarDetailsComponent,
  // NavbarSearchComponent,
  // NavbarBottomComponent,
  // HamburgerMenuComponent,
  // CarouselComponent,
  MrpTableComponent,
  FlattenObjectPipe,
  NotificationComponent,
  MrpAccountTreeComponent,
  DynamicTableComponent
];

@NgModule({
  imports: [...materialModules],
 // entryComponents: [ConfirmModalComponent],
  declarations: [...components, LoaderComponent],
  exports: [...materialModules, ...components, LoaderComponent],
})
export class SharedModule {}
